'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _reactTransitionGroup = require('react-transition-group');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SwitchCSSTransitionGroup = function (_Component) {
  _inherits(SwitchCSSTransitionGroup, _Component);

  function SwitchCSSTransitionGroup() {
    _classCallCheck(this, SwitchCSSTransitionGroup);

    return _possibleConstructorReturn(this, (SwitchCSSTransitionGroup.__proto__ || Object.getPrototypeOf(SwitchCSSTransitionGroup)).apply(this, arguments));
  }

  _createClass(SwitchCSSTransitionGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var switchKey = undefined;
      _react2.default.Children.forEach(this.props.children, function (child) {
        if (child !== null && (0, _reactRouterDom.matchPath)(_this2.props.location.pathname, child.props) && switchKey === undefined) {
          switchKey = child.props.path;
        }
      });
      var transProps = {};
      for (var key in this.props) {
        if (key.indexOf('transition') === 0) {
          transProps[key] = this.props[key];
        }
      }
      return _react2.default.createElement(
        _reactTransitionGroup.CSSTransitionGroup,
        transProps,
        _react2.default.createElement(
          _reactRouterDom.Switch,
          { key: switchKey, location: this.props.location },
          this.props.children
        )
      );
    }
  }]);

  return SwitchCSSTransitionGroup;
}(_react.Component);

SwitchCSSTransitionGroup.propTypes = {
  location: _propTypes2.default.object.isRequired
};

exports.default = SwitchCSSTransitionGroup;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/switch-css-transition-group/lib/index.js
// module id = 185
// module chunks = 2